import React, { useState } from "react";
import { User, LogOut, Menu, X } from "lucide-react";
import { Translator } from "../translate";
import { Tabs } from "./tabs.tsx";

export function CustomerHeader({ currentUser, onLogout }) {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="bg-gradient-to-r from-fuchsia-500 via-purple-600 to-indigo-600 text-white">
      <div className="max-w-7xl mx-auto flex items-center justify-between p-3">

        {/* Left: User info */}
        <div className="flex items-center gap-2">
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="lg:hidden inline-flex items-center"
          >
            {menuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
          <User className="w-5 h-5" />
          <span className="font-semibold">{currentUser.name}</span>
        </div>

        {/* Middle: Desktop menu */}
        <div className="hidden lg:flex items-center gap-4">
          <Tabs />
        </div>

        {/* Right: language switch + Logout */}
        <div className="flex items-center gap-3">
          <Translator />
          <button
            onClick={onLogout}
            className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1"
          >
            <LogOut className="w-4 h-4" /> Logg ut
          </button>
        </div>
      </div>

      {/* Mobile dropdown */}
      {menuOpen && (
        <div className="lg:hidden flex flex-col gap-2 px-4 pb-3">
          <Tabs />
        </div>
      )}
    </div>
  );
}